<script lang="ts">
  import { Icon } from '@shared/ui/icon';

  import { artworksFiltersCount, artworksFilterSidebarActivity } from '@widgets/artworks-filter-sidebar/model';
</script>

<button
  class="text-default-900 dark:text-dark-900 flex items-center font-medium"
  on:click="{() => {
    artworksFilterSidebarActivity.toggle();
  }}"
>
  <Icon name="filters" focusable="false" classes="mr-3" />
  <span>Filters</span>

  {#if $artworksFiltersCount}
    <span class="bg-default-200 dark:bg-dark-400 ml-2 flex h-7 w-7 items-center justify-center rounded-full text-xs">
      {$artworksFiltersCount}
    </span>
  {/if}
</button>
